import { useDispatch } from 'react-redux';
// import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

// Redux
import { openAuthenApp } from "./../../../../../../../@core/redux/actions/auth/index";

// CSS
import styles from "./../../../../assets/css/Style.module.css";
import buttonStyles from "./../../../../assets/css/Button.module.css";

export default function BankSelect({ typePage, isUserLoggedIn, bankList, depositItems, selectBank, setSelectBank }) {
    const history = useHistory();
    const dispatch = useDispatch();

    const gotoPage = (page) => {
        history.push(page);
    };

    const gotoLogin = () => {
        dispatch(openAuthenApp({ tab: "login", show: true }));
        // history.push("/");
    };

    const handleChange = (newValue) => {
        console.log(newValue)
        setSelectBank(newValue);
    };

    const renderTextBankNone = () => {
        return (
            <div className={styles.boxNoneBankMargin}>
                <div className={styles.boxNoneBank}>
                    <div className={styles.boxNoneBankTitle}>
                        {
                            typePage === "truemoney" ?
                                "ไม่มีข้อมูลบัญชีทรูมันนี่วอลเล็ท กรุณาเพิ่มบัญชีก่อนทำรายการ"
                                :
                                "ไม่มีข้อมูลบัญชีเติมเงิน กรุณาเพิ่มบัญชีเติมเงินก่อนทำรายการ"
                        }
                    </div>
                    <br />
                    <button className={[buttonStyles.btnConfirm, buttonStyles.btnCancel].join(" ")} onClick={() => { gotoPage("/bank") }}>
                        เพิ่มบัญชีเติมเงิน
                    </button>
                    {/* <div className={styles.boxNoneBankGoto} onClick={() => { gotoPage("/bank") }}>
                        เพิ่มบัญชีเติมเงิน
                    </div> */}
                </div>
            </div>
        );
    };

    const renderBankListContent = () => {
        if (depositItems.mode === "deposit") {
            if (bankList !== null) {
                if (bankList.length > 0) {
                    if (typePage === "bank" && bankList.length > 1) {
                        return (
                            <div className={styles.boxMarginFormTop}>
                                <select key="bank_select" defaultValue={selectBank} className={[styles.selectBankStyles, "kanit"].join(" ")} style={{ width: "100%" }} onChange={(e) => { handleChange(e.target.value) }}>
                                    <option value="0" selected>เลือกบัญชีที่ต้องการใช้เติมเงิน</option>
                                    {
                                        bankList.map(item => (
                                            item?.category !== 2 && (
                                                <option key={item.id} value={item.id}>{item.bankname}, {item.account}, {item.name}</option>
                                            )
                                        ))
                                    }
                                </select>
                            </div>
                        );
                    }
                    else {
                        return (
                            <div className={styles.boxMarginFormTop}>
                                <div className={styles.boxBankCustomer}>
                                    <div className={styles.boxAccountAgentTitle}>
                                        กรุณาใช้บัญชีนี้โอนมาเท่านั้น
                                    </div>
                                    <div className={styles.boxMarginTop}>
                                        <Grid container alignItems="center" spacing={3}>
                                            <Grid item xs={2}>
                                                <img src={bankList[0].bankimg} style={{ width: "100%", borderRadius: "8px" }} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                            </Grid>
                                            <Grid item xs={10}>
                                                <div className={styles.boxAccountAgentText}>
                                                    บัญชี {
                                                        bankList[0].bankname
                                                    }
                                                    <br />
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item>
                                                            {bankList[0].account}
                                                        </Grid>
                                                        <Grid item>
                                                            {bankList[0].name}
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                }
                else {
                    return renderTextBankNone();
                }
            }
            else {
                return renderTextBankNone();
            }
        }
        else {
            return (
                <div className={styles.boxMarginFormTop}>
                    <div className={styles.boxBankCustomer}>
                        <div className={styles.boxAccountAgentTitle}>
                            กรุณาใช้บัญชีนี้โอนมาเท่านั้น
                        </div>
                        <div className={styles.boxMarginTop}>
                            <Grid container alignItems="center" spacing={3}>
                                <Grid item xs={2}>
                                    <img src={depositItems.customer_bankimg} style={{ width: "100%", borderRadius: "8px" }} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                </Grid>
                                <Grid item xs={10}>
                                    <div className={styles.boxAccountAgentText}>
                                        บัญชี {
                                            depositItems.customer_bankname
                                        }
                                        <br />
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item>
                                                {depositItems.customer_bank_account}
                                            </Grid>
                                            <Grid item>
                                                {depositItems.customer_bank_account_name}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            );
        }
    };

    // useEffect(() => {
    //     if(depositItems.mode !== "pay") {

    //     }
    // }, [depositItems, bankList]);

    return (
        <>
            {
                isUserLoggedIn === false ?
                    <div className={styles.boxNoneBankMargin}>
                        <div className={styles.boxNoneBank}>
                            <div className={styles.boxNoneBankTitle} style={{ color: "white" }}>
                                ไม่สามารถทำรายการได้ เนื่องจากยังไม่ได้เข้าสู่ระบบ
                            </div>
                            <div className={styles.boxNoneBankGoto} onClick={() => { gotoLogin() }}>
                                คลิ๊ก ไปที่หน้าเข้าสู่ระบบ
                            </div>
                        </div>
                    </div>
                    :
                    renderBankListContent()
            }
        </>
    );
}